import { type CreateCheckoutSessionInput } from '@hive/graphql';
import { mixpanel } from '@hive/track';
import { OnEvent, Service } from '@toeverything/infra';

import { ApplicationFocused } from '../../lifecycle';
import { Subscription } from '../entities/subscription';
import { SubscriptionPrices } from '../entities/subscription-prices';
import { AccountChanged } from '../events/account-changed';
import type { SubscriptionStore } from '../stores/subscription';

@OnEvent(AccountChanged, e => e.onAccountChanged)
@OnEvent(ApplicationFocused, e => e.onApplicationFocused)
export class SubscriptionService extends Service {
  subscription = this.framework.createEntity(Subscription);
  prices = this.framework.createEntity(SubscriptionPrices);

  constructor(private readonly store: SubscriptionStore) {
    super();
    this.subscription.ai$
      .map(sub => !!sub)
      .distinctUntilChanged()
      .subscribe(ai => {
        mixpanel.people.set({
          ai,
        });
      });
    this.subscription.pro$
      .map(sub => !!sub)
      .distinctUntilChanged()
      .subscribe(pro => {
        mixpanel.people.set({
          pro,
        });
      });
  }

  async createCheckoutSession(input: CreateCheckoutSessionInput) {
    return await this.store.createCheckoutSession(input);
  }

  private onAccountChanged() {
    this.subscription.revalidate();
  }

  private onApplicationFocused() {
    // Revalidate subscription when window gains focus (e.g., after returning from Stripe checkout)
    this.subscription.revalidate();
  }
}
